module.exports = __webpack_public_path__ + "static/img/lvdou.95155832.png";